<template>
  <div class="small-feature-wrapper">
    <img
      :src="require('@/assets/ico/' + iconName + '.svg')"
      :alt="altTxt"
      class="icon"
    >
    <div>
      <span v-if="csBadge">{{ $t("comingSoon") }}</span>
      <h5>{{ title }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeatureSmall",
  props: {
    title: String,
    iconName: String,
    altTxt: String,
    csBadge: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.small-feature-wrapper {
  padding: 15px 26px;
  display: flex;
  align-items: center;
  width: 100%;

  img {
    margin-right: 28px;
  }

  @include respond-above(sm) {
    width: 50%;
  }
  @include respond-above(md) {
    width: 33%;
    padding: 30px;
  }

  span {
    background-color: $yellow;
    display: inline-block;
    // color: white;
    font-family: $bold;
    padding: 2px 6px 4px;
    font-size: 14px;
    line-height: 1em;
  }
}
</style>
